import { Route } from "react-router-dom";
import HomeScreen from "../screens/user/HomeScreen";
import ListingsScreen from "../screens/user/ListingsScreen";
import PromotionsScreen from "../screens/user/PromotionsScreen";
import ContentScreen from "../screens/user/ContentScreen";
import SettingsScreen from "../screens/user/SettingsScreen";
import Post from "../components/post/Post";
import UserListing from "../components/listings/listing/UserListing";
import CreateListings from "../components/listings/create_listing/CreateListings";
import CreateCampaign from "../screens/user/CreateCampaign";
import SocialConnections from "../components/settings/Connections/SocialConnections";
import NotificationPreferences from "../components/settings/NotificationPreferences";
import ManageTeam from "../components/settings/ManageTeam";
import PersonalInformation from "../components/settings/PersonalInformation";
import Subscription from "../components/settings/Subscription/Subscription";
import HelpScreen from "../screens/user/HelpScreen";
import { ConnectionsRedirect } from "../screens/ConnectionsRedirect";
import { SocketProvider } from "../context/SocketContext";
import TutorialDetail from "../components/help/tutorials/TutorialDetails";
import PostRedirect from "../components/post/PostRedirect";
import NotificationsPage from "../screens/user/NotificationScreen";
import ApplicationSettings from "../components/settings/ApplicationSettings/ApplicationSettings";
import MlsDetails from "../components/settings/MlsDetails/MlsDetails";
import BrandingSettings from "../components/settings/Branding/BrandingSettings";
import AutoVideoPreferences from "../components/settings/AutoVideoPreferences/AutoVideoPreferences";
import Autopilot from "../components/settings/Autopilot/Autopilot";
import ContentCleanup from "../components/settings/ContentCleanup/ContentCleanup";
import Commercial from "../components/settings/Commercial/Commercial";
import AnalyticsScreen from "../screens/user/AnalyticsScreen";
import MyNicheScreen from "../screens/user/MyNicheScreen";
import MyNicheSettings from "../components/settings/MyNiche/MyNicheSettings";
import AddPostScreen from "../components/add-post/AddPostScreen";

const userRoutes = (mlsApproved: boolean | null, mlsWelcome: boolean) => (
    <>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/help" element={<HelpScreen />} />
        <Route path="/help/*" element={<TutorialDetail />} />
        <Route
            path="/listings"
            element={
                <ListingsScreen
                    mlsApproved={mlsApproved}
                    mlsWelcome={mlsWelcome}
                />
            }
        />
        <Route
            path="/create-listing"
            element={
                <CreateListings
                    mlsApproved={mlsApproved || false}
                    mlsWelcome={mlsWelcome}
                />
            }
        />
        <Route
            path="/listing"
            element={
                <SocketProvider>
                    <UserListing mlsApproved={mlsApproved} />
                </SocketProvider>
            }
        />
        <Route path="/create-campaign" element={<CreateCampaign />} />
        {/* Same wizard; the separate path only so the URL says which mode the
            user is in. Edit mode is still driven by `editCampaignId` in the
            navigation state, not by the path. */}
        <Route path="/edit-campaign" element={<CreateCampaign />} />
        <Route path="/promotions" element={<PromotionsScreen />} />
        <Route
            path="/my-content"
            element={
                <SocketProvider>
                    <ContentScreen mlsApproved={mlsApproved} />
                </SocketProvider>
            }
        />
        <Route path="/analytics" element={<AnalyticsScreen />} />
        <Route path="/my-niche" element={<MyNicheScreen />} />
        <Route path="/add-post" element={<AddPostScreen />} />
        <Route path="/add-post/:card" element={<AddPostScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
        {/* MB-1481: commercial listings are MLS-sync-only — a non-realtor
        has no commercial settings to configure, so the screen is not
        routable for them (same gate as auto-video-preferences below). */}
        {mlsApproved && (
            <Route path="/settings/commercial" element={<Commercial />} />
        )}
        <Route
            path="/settings/connections"
            element={
                <SocketProvider>
                    <SocialConnections />
                </SocketProvider>
            }
        />
        <Route path="/connections/redirect" element={<ConnectionsRedirect />} />
        <Route
            path="/settings/notification-preferences"
            element={<NotificationPreferences />}
        />
        <Route path="/settings/manage-team" element={<ManageTeam />} />
        <Route
            path="/settings/personal-information"
            element={<PersonalInformation />}
        />
        <Route path="/settings/mls-details" element={<MlsDetails />} />
        {/* Autopilot is routable for everyone: the page itself renders a locked
        upsell state for plans without it and a prerequisites checklist until
        MLS access + sync + socials are in place. */}
        <Route path="/settings/autopilot" element={<Autopilot />} />
        <Route path="/settings/my-niche" element={<MyNicheSettings />} />
        <Route path="/settings/subscription" element={<Subscription />} />
        <Route
            path="/settings/application-settings"
            element={<ApplicationSettings />}
        />
        <Route
            path="/settings/content-cleanup"
            element={<ContentCleanup />}
        />
        <Route path="/settings/branding" element={<BrandingSettings />} />
        {/* MB-1314 (§O5): auto-video is MLS-only — a non-realtor has no auto-video
        to configure, so the screen is not routable for them. */}
        {mlsApproved && (
            <Route
                path="/settings/auto-video-preferences"
                element={<AutoVideoPreferences />}
            />
        )}
        <Route
            path="/post"
            element={
                <SocketProvider>
                    <Post />
                </SocketProvider>
            }
        />
        <Route path="/post/:id" element={<PostRedirect />} />
        <Route path="/notifications" element={<NotificationsPage />} />
    </>
);

export default userRoutes;
